import { render, staticRenderFns } from "./scroll-x-bar.vue?vue&type=template&id=7cefbbc5"
import script from "./scroll-x-bar.vue?vue&type=script&lang=js"
export * from "./scroll-x-bar.vue?vue&type=script&lang=js"
import style0 from "./scroll-x-bar.vue?vue&type=style&index=0&id=7cefbbc5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../ymoffers/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports